import styled from "styled-components";

export const UiRuleSearchCategoryContainer = styled.div`
	overflow-y: auto;
	height: 100%;
`;
